/* eslint-disable */
import { Timestamp } from "../../../../google/protobuf/timestamp";

export const protobufPackage = "od_protos.journey.data.categories";

export interface SellFinalOfferCallCategory {
  event?:
    | { $case: "proposed"; proposed: SellFinalOfferCallCategory_FinalOfferCallProposedEvent }
    | { $case: "scheduled"; scheduled: SellFinalOfferCallCategory_FinalOfferCallScheduledEvent }
    | { $case: "rescheduled"; rescheduled: SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent }
    | { $case: "canceled"; canceled: SellFinalOfferCallCategory_FinalOfferCallCanceledEvent }
    | { $case: "scheduleReminder"; scheduleReminder: SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent }
    | undefined;
}

export interface SellFinalOfferCallCategory_FinalOfferCallProposedEvent {
  sellerLeadUuid: string;
  offerUuid: string;
}

export interface SellFinalOfferCallCategory_FinalOfferCallScheduledEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  scheduledDatetime?: Date | undefined;
}

export interface SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  scheduledDatetime?: Date | undefined;
}

export interface SellFinalOfferCallCategory_FinalOfferCallCanceledEvent {
  sellerLeadUuid: string;
  offerUuid: string;
}

export interface SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent {
  sellerLeadUuid: string;
  offerUuid: string;
}

function createBaseSellFinalOfferCallCategory(): SellFinalOfferCallCategory {
  return { event: undefined };
}

export const SellFinalOfferCallCategory = {
  fromJSON(object: any): SellFinalOfferCallCategory {
    return {
      event: isSet(object.proposed)
        ? {
          $case: "proposed",
          proposed: SellFinalOfferCallCategory_FinalOfferCallProposedEvent.fromJSON(object.proposed),
        }
        : isSet(object.scheduled)
        ? {
          $case: "scheduled",
          scheduled: SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.fromJSON(object.scheduled),
        }
        : isSet(object.rescheduled)
        ? {
          $case: "rescheduled",
          rescheduled: SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.fromJSON(object.rescheduled),
        }
        : isSet(object.canceled)
        ? {
          $case: "canceled",
          canceled: SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.fromJSON(object.canceled),
        }
        : isSet(object.scheduleReminder)
        ? {
          $case: "scheduleReminder",
          scheduleReminder: SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.fromJSON(
            object.scheduleReminder,
          ),
        }
        : undefined,
    };
  },

  toJSON(message: SellFinalOfferCallCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "proposed") {
      obj.proposed = SellFinalOfferCallCategory_FinalOfferCallProposedEvent.toJSON(message.event.proposed);
    }
    if (message.event?.$case === "scheduled") {
      obj.scheduled = SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.toJSON(message.event.scheduled);
    }
    if (message.event?.$case === "rescheduled") {
      obj.rescheduled = SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.toJSON(message.event.rescheduled);
    }
    if (message.event?.$case === "canceled") {
      obj.canceled = SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.toJSON(message.event.canceled);
    }
    if (message.event?.$case === "scheduleReminder") {
      obj.scheduleReminder = SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.toJSON(
        message.event.scheduleReminder,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellFinalOfferCallCategory>, I>>(base?: I): SellFinalOfferCallCategory {
    return SellFinalOfferCallCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellFinalOfferCallCategory>, I>>(object: I): SellFinalOfferCallCategory {
    const message = createBaseSellFinalOfferCallCategory();
    if (object.event?.$case === "proposed" && object.event?.proposed !== undefined && object.event?.proposed !== null) {
      message.event = {
        $case: "proposed",
        proposed: SellFinalOfferCallCategory_FinalOfferCallProposedEvent.fromPartial(object.event.proposed),
      };
    }
    if (
      object.event?.$case === "scheduled" && object.event?.scheduled !== undefined && object.event?.scheduled !== null
    ) {
      message.event = {
        $case: "scheduled",
        scheduled: SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.fromPartial(object.event.scheduled),
      };
    }
    if (
      object.event?.$case === "rescheduled" &&
      object.event?.rescheduled !== undefined &&
      object.event?.rescheduled !== null
    ) {
      message.event = {
        $case: "rescheduled",
        rescheduled: SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.fromPartial(object.event.rescheduled),
      };
    }
    if (object.event?.$case === "canceled" && object.event?.canceled !== undefined && object.event?.canceled !== null) {
      message.event = {
        $case: "canceled",
        canceled: SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.fromPartial(object.event.canceled),
      };
    }
    if (
      object.event?.$case === "scheduleReminder" &&
      object.event?.scheduleReminder !== undefined &&
      object.event?.scheduleReminder !== null
    ) {
      message.event = {
        $case: "scheduleReminder",
        scheduleReminder: SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.fromPartial(
          object.event.scheduleReminder,
        ),
      };
    }
    return message;
  },
};

function createBaseSellFinalOfferCallCategory_FinalOfferCallProposedEvent(): SellFinalOfferCallCategory_FinalOfferCallProposedEvent {
  return { sellerLeadUuid: "", offerUuid: "" };
}

export const SellFinalOfferCallCategory_FinalOfferCallProposedEvent = {
  fromJSON(object: any): SellFinalOfferCallCategory_FinalOfferCallProposedEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
    };
  },

  toJSON(message: SellFinalOfferCallCategory_FinalOfferCallProposedEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallProposedEvent>, I>>(
    base?: I,
  ): SellFinalOfferCallCategory_FinalOfferCallProposedEvent {
    return SellFinalOfferCallCategory_FinalOfferCallProposedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallProposedEvent>, I>>(
    object: I,
  ): SellFinalOfferCallCategory_FinalOfferCallProposedEvent {
    const message = createBaseSellFinalOfferCallCategory_FinalOfferCallProposedEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    return message;
  },
};

function createBaseSellFinalOfferCallCategory_FinalOfferCallScheduledEvent(): SellFinalOfferCallCategory_FinalOfferCallScheduledEvent {
  return { sellerLeadUuid: "", offerUuid: "", scheduledDatetime: undefined };
}

export const SellFinalOfferCallCategory_FinalOfferCallScheduledEvent = {
  fromJSON(object: any): SellFinalOfferCallCategory_FinalOfferCallScheduledEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      scheduledDatetime: isSet(object.scheduledDatetime) ? fromJsonTimestamp(object.scheduledDatetime) : undefined,
    };
  },

  toJSON(message: SellFinalOfferCallCategory_FinalOfferCallScheduledEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.scheduledDatetime !== undefined) {
      obj.scheduledDatetime = message.scheduledDatetime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallScheduledEvent>, I>>(
    base?: I,
  ): SellFinalOfferCallCategory_FinalOfferCallScheduledEvent {
    return SellFinalOfferCallCategory_FinalOfferCallScheduledEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallScheduledEvent>, I>>(
    object: I,
  ): SellFinalOfferCallCategory_FinalOfferCallScheduledEvent {
    const message = createBaseSellFinalOfferCallCategory_FinalOfferCallScheduledEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.scheduledDatetime = object.scheduledDatetime ?? undefined;
    return message;
  },
};

function createBaseSellFinalOfferCallCategory_FinalOfferCallRescheduledEvent(): SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent {
  return { sellerLeadUuid: "", offerUuid: "", scheduledDatetime: undefined };
}

export const SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent = {
  fromJSON(object: any): SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      scheduledDatetime: isSet(object.scheduledDatetime) ? fromJsonTimestamp(object.scheduledDatetime) : undefined,
    };
  },

  toJSON(message: SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.scheduledDatetime !== undefined) {
      obj.scheduledDatetime = message.scheduledDatetime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent>, I>>(
    base?: I,
  ): SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent {
    return SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent>, I>>(
    object: I,
  ): SellFinalOfferCallCategory_FinalOfferCallRescheduledEvent {
    const message = createBaseSellFinalOfferCallCategory_FinalOfferCallRescheduledEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.scheduledDatetime = object.scheduledDatetime ?? undefined;
    return message;
  },
};

function createBaseSellFinalOfferCallCategory_FinalOfferCallCanceledEvent(): SellFinalOfferCallCategory_FinalOfferCallCanceledEvent {
  return { sellerLeadUuid: "", offerUuid: "" };
}

export const SellFinalOfferCallCategory_FinalOfferCallCanceledEvent = {
  fromJSON(object: any): SellFinalOfferCallCategory_FinalOfferCallCanceledEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
    };
  },

  toJSON(message: SellFinalOfferCallCategory_FinalOfferCallCanceledEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallCanceledEvent>, I>>(
    base?: I,
  ): SellFinalOfferCallCategory_FinalOfferCallCanceledEvent {
    return SellFinalOfferCallCategory_FinalOfferCallCanceledEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallCanceledEvent>, I>>(
    object: I,
  ): SellFinalOfferCallCategory_FinalOfferCallCanceledEvent {
    const message = createBaseSellFinalOfferCallCategory_FinalOfferCallCanceledEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    return message;
  },
};

function createBaseSellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent(): SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent {
  return { sellerLeadUuid: "", offerUuid: "" };
}

export const SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent = {
  fromJSON(object: any): SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
    };
  },

  toJSON(message: SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent>, I>>(
    base?: I,
  ): SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent {
    return SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent>, I>>(
    object: I,
  ): SellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent {
    const message = createBaseSellFinalOfferCallCategory_FinalOfferCallScheduleReminderEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
